module.exports = __webpack_public_path__ + "static/media/client-logo-14.5dee987d.jpg";